import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { TableParams } from '../order-grid/search-params.model';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private orderSearchSubject = new BehaviorSubject<string | null>(null);
  orderSearchTerm$ = this.orderSearchSubject.asObservable();

  private breadcrumbPathSource = new BehaviorSubject<MenuItem[]>([
    { label: 'Orders List' }
  ]);
  breadcrumbPath$ = this.breadcrumbPathSource.asObservable();

  OrderGridParams:TableParams = {
    sortField: 'number',
    sortOrder: -1,
    first: 0,
    rowsPerPage: 10,
    orderOwner: [],
    orderType: [],
    accountName: [],
    createdBy: [],
    updatedFilterValues: false,
    clientName: []
  }
  constructor() { }

  setOrderSearchTerm(orderId: string | null) {
    this.orderSearchSubject.next(orderId);
  }

  updateBreadcrumbPath(path: MenuItem[]) {
    this.breadcrumbPathSource.next(path);
  }
}
